<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="1">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.agente_id"
            :items="operadores"
            label="agente"
            @change="getAgente(form.agente_id)"
            @input="$v.form.agente_id.$touch()"
            @blur="$v.form.agente_id.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import { registerVuexModule } from '@/utils/vuexUtils'

import tarefasStore from '../_store'
import { validateData, validateComputed } from '../_validates/validateDeslogarAgente'

export default {
  name: 'DeslogarAgente',
  props: {
    acao: Object,
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      active: true,
      description: 'DESLOGAR AGENTE',
      tipo: 'deslogarAgente',
      agente_id: '',
      agente_name: '',
    },
    dataRamais: [],
    operadores: [],
    showSkeleton: true,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('acaoDeslogarAgenteAgendamentoTarefaModulePABXStore', ['getOperadores']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'acaoDeslogarAgenteAgendamentoTarefaModulePABXStore', tarefasStore)

    await this.listarOperadores()

    this.operadores = this.getOperadores.map(operador => ({
      text: `${operador.numero} - ${operador.usuario}`,
      value: operador._id,
    }))

    this.form = Object.assign({}, this.acao)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('acaoDeslogarAgenteAgendamentoTarefaModulePABXStore', ['listarOperadores']),

    getAgente(operador_id) {
      if (operador_id) {
        const operador = this.getOperadores.filter(operador => operador._id === operador_id)
        this.form.agente_name = `${operador[0].numero} - ${operador[0].usuario}`
      }
    },
  },

  watch: {
    form: {
      deep: true,
      handler(novo) {
        this.$emit('form', novo)
        this.$emit('error', this.$v)
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
